import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Nav() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/api/user-info", {
          withCredentials: true,
        });
        setIsAuthenticated(true);
      } catch (err) {
        setIsAuthenticated(false);
      }
    };

    fetchData();
  }, []);

  const navigate = useNavigate();

  const handleClick = async () => {
    setIsAuthenticated(false);
    const response = await axios.get("/api/logout");
    navigate("/login");
  };
  return (
    <>
      <nav className="site-nav">
        <a
          className="site-brand"
          href="/#inicio"
          aria-label="Centro Divergente, inicio"
        >
          <img
            src="/img/divergente.png"
            alt="Centro Divergente"
            className="logo"
          />
        </a>
        <div className="site-menu">
          <a href="/#nosotros">Nosotros</a>
          <a href="/#enfoque">Enfoque</a>
          <a href="/#principios">Principios</a>
          {/*<a href="/#equipo">Equipo</a>
          <a href="/#cursos">Cursos</a>*/}
          <a href="/#contacto">Contacto</a>
        </div>
        <div className="site-account">
          {isAuthenticated ? (
            <>
              <a className="link" onClick={handleClick}>
                Cerrar Sesión
              </a>
            </>
          ) : (
            <>
              <a href="/login">Iniciar Sesión</a>
            </>
          )}
        </div>
      </nav>
    </>
  );
}
